export default __webpack_public_path__ + "static/media/certificates_1.51ec5511.jpeg";